import{useFirstMountState as t}from"./useFirstMountState.js";import{useEffect as e}from"react";var r=(r,s)=>{const a=t();e(()=>{if(!a)return r()},s)};export{r as useUpdateEffect};
//# sourceMappingURL=useUpdateEffect.js.map